const deriveSimpleModel = require("./deriveSimpleModel");
const applyCommands = require("./applyCommands");

function squashHistory(commandList, snap) {
    let snapCmds = commandList.slice(0);

    // find all commands after the latest snap id
    if (snap.id) {
        while (snapCmds.length && snapCmds[0].id <= snap.id) {
            snapCmds.shift();
        }
    }

    // we can only update the snapshot up to our first queued command
    for (let ii = 0; ii < snapCmds.length; ii++) {
        if (snapCmds[ii].queued) {
            snapCmds = snapCmds.slice(0, ii);
        }
    }

    let updates = snapCmds.reduce((lst, cmd) => lst.concat(JSON.parse(cmd.updates)), []);
    let newModel = applyCommands(JSON.parse(snap.model || "{}"), updates);
    let simpleModel = deriveSimpleModel(newModel);
    return { simpleModel, newModel };
}

module.exports = squashHistory;
